import { render, staticRenderFns } from "./equiinfo.vue?vue&type=template&id=8171772e&scoped=true"
import script from "./equiinfo.vue?vue&type=script&lang=js"
export * from "./equiinfo.vue?vue&type=script&lang=js"
import style0 from "./equiinfo.vue?vue&type=style&index=0&id=8171772e&lang=scss&scoped=true"
import style1 from "./equiinfo.vue?vue&type=style&index=1&id=8171772e&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8171772e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-manage/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8171772e')) {
      api.createRecord('8171772e', component.options)
    } else {
      api.reload('8171772e', component.options)
    }
    module.hot.accept("./equiinfo.vue?vue&type=template&id=8171772e&scoped=true", function () {
      api.rerender('8171772e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/equipment/equiinfo.vue"
export default component.exports